// extracted by mini-css-extract-plugin
export default {"drawer":"SponsoredDrawerShell_drawer__ZDk1Y"};